import Vue from 'vue';
import {$eventBus, EVENT_SHOW_ALERT, EVENT_SHOW_CONFIRM} from '@common/utils/event.js';

export const $showConfirm = ({title, titleHtml, desc, descHtml, okText, cancelText, ok, cancel, afterClose, width}) => {
    $eventBus.$emit(EVENT_SHOW_CONFIRM, {
        title,
        titleHtml,
        desc,
        descHtml,
        okText,
        cancelText,
        ok,
        cancel,
        afterClose,
        width,
    });
};

export const $showAlert = ({title, titleHtml, desc, descHtml, okText, ok, afterClose, width}) => {
    $eventBus.$emit(EVENT_SHOW_ALERT, {title, titleHtml, desc, descHtml, okText, ok, afterClose, width});
};

Object.defineProperties(Vue.prototype, {
    $showConfirm: {
        get() {
            return $showConfirm;
        }
    },
    $showAlert: {
        get() {
            return $showAlert;
        }
    }
});
